export const SERIE_LIST_REQUEST = "SERIE_LIST_REQUEST";
export const SERIE_LIST_SUCCESS = "SERIE_LIST_SUCCESS";
export const SERIE_LIST_FAIL = "SERIE_LIST_FAIL";

export const SERIE_EDIT_REQUEST = "SERIE_EDIT_REQUEST";
export const SERIE_EDIT_SUCCESS = "SERIE_EDIT_SUCCESS";
export const SERIE_EDIT_FAIL = "SERIE_EDIT_FAIL";

export const SERIE_DELETE_REQUEST = "SERIE_DELETE_REQUEST";
export const SERIE_DELETE_SUCCESS = "SERIE_DELETE_SUCCESS";
export const SERIE_DELETE_FAIL = "SERIE_DELETE_FAIL";

export const SERIE_CREATE_REQUEST = "SERIE_CREATE_REQUEST";
export const SERIE_CREATE_SUCCESS = "SERIE_CREATE_SUCCESS";
export const SERIE_CREATE_FAIL = "SERIE_CREATE_FAIL";
export const SERIE_CREATE_RESET = "SERIE_CREATE_RESET";

export const SERIE_UPDATE_REQUEST = "SERIE_UPDATE_REQUEST";
export const SERIE_UPDATE_SUCCESS = "SERIE_UPDATE_SUCCESS";
export const SERIE_UPDATE_FAIL = "SERIE_UPDATE_FAIL";
export const SERIE_UPDATE_RESET = "SERIE_UPDATE_RESET";